export default __webpack_public_path__ + "static/media/product.fd0cc0ee.svg";